// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-06977c7a]{font-size:.7rem;color:#a9a9a9}", ""]);
// Exports
module.exports = exports;
